// extracted by mini-css-extract-plugin
export default {"typeaheadPopover":"emoji-picker-plugin_typeaheadPopover__KRbAt","emojiItem":"emoji-picker-plugin_emojiItem__sFADr","selectedEmojiItem":"emoji-picker-plugin_selectedEmojiItem__ksnFI"};